import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { ArrowIcon, DownloadIcon, EditIcon } from '../../components/icons';
import IconButton from '../../components/IconButton';
import { GetDateInCurrentTimeZone } from '../../components/utilities/dateUtilities';

import {
  BackStyles,
  DetailWrap,
  DownloadStyles,
  InnerDetail,
  OrderedStyles,
  TitleNumber,
  TitleNumberWrap,
} from './styles';
import Priority from './Priority';
import { Order } from '../types';

const DownloadOptions = styled.div`
  position: absolute;
  background-color: white;
  border: 1px solid #000000;
  padding: 24px 40px 24px 24px;
  left: 0px;
  top: 56px;
  width: 154px;
  z-index: 50;
`;
const DownloadOptionStyles = styled.div`
  margin-top: 8px;
  font-size: 16px;
  cursor: pointer;
  color: #444340;
  :hover {
    color: #bcc2c7;
  }
`;
const EditOptions = styled.div`
  background-color: white;
  border: 1px solid #000000;
  left: -32px;
  padding: 24px 40px 24px 24px;
  position: absolute;
  top: 44px;
  width: 175px;
  z-index: 50;
  div {
    color: #93918f;
    font-size: 12px;
    text-transform: uppercase;
  }
`;
const OnHoldCancelled = styled.div`
  display: flex;
  align-items: center;
  /* position: absolute;
  right: 0px; */
  z-index: 50;
  color: #e52c2c;
`;
interface Props {
  order: Order;
  priority: string;
  download: (merge: boolean) => void;
  getPriority: () => string;
  setPriority: (priority: string) => void;
  showDownload?: boolean;
}
const OrderSummary = (props: Props) => {
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  useEffect(() => {
    window.addEventListener('click', () => {
      setDownloadOpen(false);
      setEditOpen(false);
    });
    return () => {
      window.removeEventListener('click', () => {
        setDownloadOpen(false);
        setEditOpen(false);
      });
    };
  }, []);
  return (
    <>
      <DetailWrap>
        <TitleNumberWrap>
          <BackStyles href="/home">
            <ArrowIcon style={{ transform: 'rotate(180deg)' }} />
          </BackStyles>
          <div className="flex jcsb aic">{/* <TitleNumber>{props.order.titleNumber}</TitleNumber> */}</div>
        </TitleNumberWrap>
        <InnerDetail>
          <div className="flex aic relative">
            <div className="relative">
              Priority: <span style={{ fontWeight: 600, fontSize: 15 }}>{props.getPriority()}</span>
              {editOpen && (
                <EditOptions>
                  <div>Change Priority</div>
                  <Priority priority={props.getPriority()} onChange={props.setPriority} />
                </EditOptions>
              )}
            </div>
            <IconButton
              icon={<EditIcon />}
              onClick={(e: MouseEvent) => {
                e.stopPropagation();
                setEditOpen(!editOpen);
              }}
              backgroundColor={editOpen ? '#BCC2C7' : 'transparent'}
            />

            {props.order.statusId === 2 && <OnHoldCancelled>On Hold</OnHoldCancelled>}
            {props.order.statusId === 3 && <OnHoldCancelled>Cancelled</OnHoldCancelled>}
          </div>
          {props.showDownload && (
            <div style={{ position: 'relative' }}>
              <DownloadStyles>
                <IconButton
                  icon={<DownloadIcon />}
                  onClick={(e: MouseEvent) => {
                    e.stopPropagation();
                    setDownloadOpen(!downloadOpen);
                  }}
                  backgroundColor={downloadOpen ? '#BCC2C7' : 'transparent'}
                />
              </DownloadStyles>
              {downloadOpen && (
                <DownloadOptions>
                  <div
                    style={{
                      color: '#93918F',
                      fontSize: 12,
                      textTransform: 'uppercase',
                    }}
                  >
                    Download
                  </div>
                  <DownloadOptionStyles onClick={() => props.download(false)}>
                    Download Individual Documents
                  </DownloadOptionStyles>
                  <DownloadOptionStyles onClick={() => props.download(true)}>
                    Merge Documents & Download
                  </DownloadOptionStyles>
                </DownloadOptions>
              )}
            </div>
          )}
          {/* <OrderedStyles>
            Ordered: <span>{GetDateInCurrentTimeZone(props.order.orderDate).format('MM/DD/YYYY')}</span>
          </OrderedStyles> */}
        </InnerDetail>
      </DetailWrap>
    </>
  );
};

export default OrderSummary;
